import ExpandMore from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { FC, memo } from 'react';

import { MARTIAL_ARTS_FAQ } from '../../assets/data/kampfkunst-faq';
import { H2Gold } from '../../components/ColoredHeading';
import GenericLayout from '../../components/GenericLayout';
import NoPageImageSection from '../../components/NoPageImageSection';
import { COLOR } from '../../types/theme';
import { colorToCss } from '../../utils/theme';

const MartialArtsFaq: FC = () => (
  <GenericLayout title='FAQ'>
    <NoPageImageSection background={colorToCss(COLOR.Dark3)}>
      <H2Gold>Fragen und Antworten</H2Gold>

      <Container>
        {MARTIAL_ARTS_FAQ.map(({ a, q }) => (
          <Accordion key={q} slotProps={{ transition: { unmountOnExit: true } }}>
            <AccordionSummary
              aria-controls='panel-content'
              expandIcon={<ExpandMore />}
              id='panel-header'
            >
              <Typography component='span'>{q}</Typography>
            </AccordionSummary>
            <AccordionDetails>{a}</AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </NoPageImageSection>
  </GenericLayout>
);

export default memo(MartialArtsFaq);
